import { ITooltipParams } from 'ag-grid-community'
import { borderRadiusSystem, colorSystem } from '@/styles/theme'
import Text from '@/components/content/Text'
import styled from 'styled-components'

export const GridTooltip = (props: ITooltipParams) => {
  return (
    <GridTooltipWrapper>
      <Text kind="Body_12_medium" color={colorSystem.text.common.inverse}>
        {props.value}
      </Text>
    </GridTooltipWrapper>
  )
}

const GridTooltipWrapper = styled.div`
  padding: 8px 12px;
  background: ${colorSystem.bg.common.dim};
  border-radius: ${borderRadiusSystem.md}px;
  white-space: pre-line;
  &:after {
    content: '';
    display: block;
    position: absolute;
    top: -6px;
    left: calc(50% - 4px);
    width: 8px;
    height: 6px;
    background: ${colorSystem.bg.common.dim};
    clip-path: polygon(50% 0%, 0 100%, 100% 100%);
  }
`
